
    import { defineComponent } from 'vue'
    import { iOutputColumn } from '../../FunctionsCatalog'
    import Card from 'primevue/card'
    import FunctionsCatalogOutputColumn from './FunctionsCatalogOutputColumn.vue'

    export default defineComponent({
        name: 'function-catalog-output-columns-card',
        components: { Card, FunctionsCatalogOutputColumn },
        props: { columns: { type: Array }, readonly: { type: Boolean } },
        data() {
            return {
                outputColumns: [] as iOutputColumn[]
            }
        },
        created() {
            this.loadOutputColumns()
        },
        methods: {
            loadOutputColumns() {
                this.outputColumns = this.columns as iOutputColumn[]
            },
            addOutputColumn() {
                this.outputColumns.push({ name: '', fieldType: '', type: '' })
            },
            deleteOutputColumn(index: number) {
                this.outputColumns.splice(index, 1)
            }
        }
    })
